// extracted by mini-css-extract-plugin
export default {"container":"Details_container__ltjGt","card":"Details_card__XTANV"};